import React from "react";
import Table from "../../../../../../common/element/Table";
const { Tr, Th, Td, THead, TBody } = Table;
const DataList = ({ data, handleSort, getAllinvitedData, showClientsAssignedColumn }) => {
  return (
    <React.Fragment>
      <div className="overflow-hidden border rounded-lg border-gray-200 cstm-table">
        <Table>
          <THead>
            <Tr>
              {/* <Th onClick={(e) => handleSort(e, "provider_type_name")}>
                <span className="flex items-center gap-1">
                  Provider type
                  <svg
                    className={`transform ${getAllinvitedData.sort === "provider_type_name" &&
                        getAllinvitedData.order === "asc"
                        ? "rotate-180"
                        : ""
                      }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th> */}
              
              <Th onClick={(e) => handleSort(e, "provider_id")}>
                <span className="flex items-center gap-1">
                  Provider ID
                  <svg
                    className={`transform ${getAllinvitedData.sort === "provider_id" &&
                      getAllinvitedData.order === "asc"
                      ? "rotate-180"
                      : ""
                      }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th onClick={(e) => handleSort(e, "provider_trading_name")}>
                <span className="flex items-center gap-1">
                  Provider Name
                  <svg
                    className={`transform ${getAllinvitedData.sort === "provider_trading_name" &&
                      getAllinvitedData.order === "asc"
                      ? "rotate-180"
                      : ""
                      }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th>Contact Name</Th>
              <Th>Email Address</Th>
              <Th>Phone Number</Th>
              <Th>ABN/NZBN</Th>
              {showClientsAssignedColumn && <Th>Clients Assigned</Th>}
              <Th>Status</Th>
              {/* <Th>Reason</Th> */}
              <Th>State</Th>
              <Th>Client Contact</Th>
              {/* <Th>Workers No.</Th> */}
              {/* <Th onClick={(e) => handleSort(e, "creation_date")}>
                <span className="flex items-center gap-1">
                  Creation date
                  <svg
                    className={`transform ${getAllinvitedData.sort === "creation_date" &&
                        getAllinvitedData.order === "asc"
                        ? "rotate-180"
                        : ""
                      }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th onClick={(e) => handleSort(e, "approval_date")}>
                <span className="flex items-center gap-1">
                  Approval date
                  <svg
                    className={`transform ${getAllinvitedData.sort === "approval_date" &&
                        getAllinvitedData.order === "asc"
                        ? "rotate-180"
                        : ""
                      }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th onClick={(e) => handleSort(e, "renewal_date")}>
                <span className="flex items-center gap-1">
                  Renewal date
                  <svg
                    className={`transform ${getAllinvitedData.sort === "renewal_date" &&
                        getAllinvitedData.order === "asc"
                        ? "rotate-180"
                        : ""
                      }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th>Lifetime value</Th> */}
            </Tr>
          </THead>
          <TBody>
            {data?.providers?.length > 0 &&
              data?.providers?.map((item, index) => {
                return (
                  <Tr key={index}>
                    {/* <Td>{item?.provider_type_name}</Td> */}
                    <Td>{item?.provider_org_id}</Td>
                    <Td>{item?.provider_trading_name}</Td>
                    <Td>
                      {(() => {
                        // const direct = (item?.contact_name || "").toString().trim();
                        // if (direct) {
                        //   return direct;
                        // }
                        const first = (item?.individual_data?.first_name || "")
                          .toString()
                          .trim();
                        const last = (item?.individual_data?.last_name || "")
                          .toString()
                          .trim();
                        const fullName = [first, last].filter(Boolean).join(" ").trim();
                        return fullName || "-";
                      })()}
                    </Td>
                    <Td>
                      {(() => {
                        const email =
                          item?.individual_data?.email ||
                          item?.individual_data?.email_address ||
                          item?.email ||
                          item?.client_contact_email ||
                          "";
                        const normalized = email.toString().trim().toLowerCase();
                        if (!normalized) return "-";
                        const atIndex = normalized.indexOf("@");
                        const domain = atIndex >= 0 ? normalized.slice(atIndex + 1) : "";
                        if (domain.includes("unique")) return "-";
                        return email;
                      })()}
                    </Td>
                    <Td>{item?.individual_data?.phone || item?.individual_data?.phone_optional || item?.phone || "-"}</Td>
                    <Td>{item?.provider_abn_nzbn}</Td>
                    {showClientsAssignedColumn && <Td>{item?.client_trading_name || "-"}</Td>}
                    <Td>
                      {item?.status ? (
                        <span
                          className={
                            item?.status === "Compliant"
                              ? "badge bg-success-50 text-success-700 py-0.5 px-2 rounded-lg font-medium whitespace-nowrap"
                              : item?.status === "Invited"
                                ? "badge text-gray-700 bg-gray-100 py-0.5 px-2 rounded-lg font-normal whitespace-nowrap"
                                : item?.status === "Self Registered"
                                  ? "badge text-gray-700 bg-gray-100 py-0.5 px-2 rounded-lg font-normal whitespace-nowrap"
                                  : item?.status === "Assigned"
                                    ? "badge bg-blue-50 text-blue-700 py-0.5 px-2 rounded-lg font-medium whitespace-nowrap"
                                    : item?.status === "No-clients"
                                      ? "badge bg-warning-100 text-warning-700 py-0.5 px-2 rounded-lg font-medium whitespace-nowrap"
                                      : "badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium whitespace-nowrap"
                          }
                        >
                          {item?.status === "Closed"
                            ? "Deactivated"
                            : item?.status === "No-clients" || item?.status === "Registered"
                              ? "Self-Registered"
                              : item?.status === "Assigned"
                                ? "Registered"
                                : item?.status}
                        </span>
                      ) : (
                        "-"
                      )}
                    </Td>
                    {/* <Td>{item?.change_reason}</Td> */}
                    <Td>{item?.state_name || "-"}</Td>
                    <Td>
                      {item?.client_contact_name && item.client_contact_name !== "-"
                        ? item.client_contact_name
                        : (() => {
                            const first = (item?.individual_data?.first_name || "")
                              .toString()
                              .trim();
                            const last = (item?.individual_data?.last_name || "")
                              .toString()
                              .trim();
                            const fullName = [first, last].filter(Boolean).join(" ").trim();
                            return fullName || item?.contact_name || "-";
                          })()}
                    </Td>
                    {/* <Td>{item?.worker_assigned ?? "-"}</Td> */}
                    {/* <Td>{item?.worker_assigned || "-"}</Td>
                    <Td>
                      {item?.creation_date
                        ? moment(item?.creation_date).format("DD/MM/YYYY")
                        : "-"}
                    </Td>
                    <Td>
                      {item?.last_doc_approval_date
                        ? moment(item?.last_doc_approval_date).format(
                          "DD/MM/YYYY"
                        )
                        : "-"}
                    </Td>
                    <Td>
                      {item?.renewal_date
                        ? moment(item?.renewal_date).format("DD/MM/YYYY")
                        : "-"}
                    </Td>
                    <Td>{item?.life_time_value || "-"}</Td> */}
                  </Tr>
                );
              })}
          </TBody>
        </Table>
      </div>
    </React.Fragment>
  );
};
export default DataList;
